import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'Components/Tooltip';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import styles from './AccessCode.scss';

class AccessCode extends React.PureComponent {
  render() {
    const { type, code, fadeInTooltip } = this.props;

    return (
      <div className="AccessCode">
        <div className="AccessCode__header">
          <div className="AccessCode__label">
            {type === 'school' ? (
              <ConnectedFormattedMessage id="access_code.school_label" />
            ) : (
              <ConnectedFormattedMessage id="access_code.class_label" />
            )}
          </div>
          {type === 'school' ? (
            <Tooltip
              header={
                <ConnectedFormattedMessage id="access_code.tooltip.header" />
              }
              body={
                <ConnectedFormattedMessage
                  id="access_code.tooltip.body"
                  containsHtml
                />
              }
              fadeIn={fadeInTooltip}
              id="school-code"
            />
          ) : null}
        </div>
        <div className="AccessCode__value">{code}</div>
      </div>
    );
  }
}

AccessCode.defaultProps = {
  type: 'school',
  fadeInTooltip: false,
};

AccessCode.propTypes = {
  /** We only use school codes, but it is possible to have class codes too */
  type: PropTypes.oneOf(['school', 'class']),
  /** This is the actual code that students log in with. */
  code: PropTypes.string.isRequired,
  /**
   * When a user sees this component for the first time, we show them a
   * tooltip to explain it. If it is true, we fade in and show the tooltip
   * after the component mounts.
   */
  fadeInTooltip: PropTypes.bool,
};

export default AccessCode;
